import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

import { NzTooltipDirective } from "ng-zorro-antd/tooltip";
import { NzDrawerModule } from "ng-zorro-antd/drawer";

import { LktAvatarComponent } from "../avatar/avatar.component";
import { LktChipComponent } from "../chip/chip.component";
import { UserPopoverItem } from "../user-popover/user-popover-item.interface";

@Component({
  selector: "lkt-user-bottom-sheet",
  standalone: true,
  imports: [NzDrawerModule, LktAvatarComponent, LktChipComponent, NzTooltipDirective],
  templateUrl: "./user-bottom-sheet.component.html",
  styleUrl: "./user-bottom-sheet.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LktUserBottomSheetComponent {
  public readonly visible = input<boolean>(false);
  public readonly userName = input<string>("Usuário");
  public readonly userAvatar = input<string>("");
  public readonly profileLabel = input<string>("Administrador Lekto");
  public readonly profileIcon = input<string>("uil uil-setting");
  public readonly hasMultipleProfiles = input<boolean>(false);
  public readonly items = input<UserPopoverItem[]>([]);
  public readonly version = input<string>("3.0");
  public readonly dataCy = input<string>("user-bottom-sheet");

  public readonly visibleChange = output<boolean>();
  public readonly itemClick = output<string>();
  public readonly switchProfileClick = output<void>();

  public onClose(): void {
    this.visibleChange.emit(false);
  }

  public onItemClick(itemId: string): void {
    this.itemClick.emit(itemId);
  }

  public onSwitchProfile(): void {
    this.switchProfileClick.emit();
  }
}
